"use client"

import { useState } from "react"
import { useAuth } from "../context/AuthContext"
import { User, LogOut, ChevronDown, Settings } from "lucide-react"
import Logo from "../assets/logo.png"
const Navbar = () => {
  const { user, logout } = useAuth()
  const [showDropdown, setShowDropdown] = useState(false)

  const handleLogout = async () => {
    await logout()
    setShowDropdown(false)
  }

  if (!user) return null

  return (
    <nav className="bg-black/20 backdrop-blur-xs border-bsticky top-0 z-50 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Left side - Logo and Brand */}
          <div className="flex items-center space-x-4">
            <div className="flex items-center space-x-3">
              <img src={Logo} alt="AI District Logo" className="h-12 w-auto" />
            </div>
          </div>

          {/* Right side - User menu */}
          <div className="relative">
            <button
              onClick={() => setShowDropdown(!showDropdown)}
              className="flex items-center gap-3 text-black hover:text-gray-700 transition-colors bg-white border border-gray-300 hover:bg-gray-50 rounded-lg px-4 py-2 shadow-sm min-w-0"
            >
              {/* User Avatar */}
              <div className="w-8 h-8 bg-gradient-to-br from-purple-500 to-pink-500 rounded-full flex items-center justify-center flex-shrink-0">
                <User className="h-4 w-4 text-white" />
              </div>

              {/* User Info - Hidden on small screens */}
              <div className="hidden sm:block text-left min-w-0 flex-1">
                <div className="text-sm font-medium text-black truncate">{user.name}</div>
                <div className="text-xs text-gray-600 truncate">{user.email}</div>
              </div>

              {/* Dropdown Arrow */}
              <ChevronDown className="h-4 w-4 text-gray-500 flex-shrink-0" />
            </button>

            {/* Dropdown Menu */}
            {showDropdown && (
              <>
                {/* Backdrop */}
                <div className="fixed inset-0 z-10" onClick={() => setShowDropdown(false)} />

                {/* Dropdown Content */}
                <div className="absolute right-0 mt-2 w-64 bg-white border border-gray-300 rounded-lg shadow-lg py-2 z-20">
                  {/* User info for mobile */}
                  <div className="px-4 py-3 border-b border-gray-200 sm:hidden">
                    <div className="flex items-center space-x-3">
                      <div className="w-10 h-10 bg-gradient-to-br from-purple-500 to-pink-500 rounded-full flex items-center justify-center">
                        <User className="h-5 w-5 text-white" />
                      </div>
                      <div className="min-w-0 flex-1">
                        <div className="text-sm font-medium text-black truncate">{user.name}</div>
                        <div className="text-xs text-gray-600 truncate">{user.email}</div>
                      </div>
                    </div>
                  </div>

                  {/* User info for desktop */}
                  <div className="hidden sm:block px-4 py-3 border-b border-gray-200">
                    <div className="flex items-center space-x-3">
                      <div className="w-10 h-10 bg-gradient-to-br from-purple-500 to-pink-500 rounded-full flex items-center justify-center">
                        <User className="h-5 w-5 text-white" />
                      </div>
                      <div className="min-w-0 flex-1">
                        <div className="text-sm font-medium text-black">{user.name}</div>
                        <div className="text-xs text-gray-600">{user.email}</div>
                        <div className="text-xs text-green-600 mt-1">● Online</div>
                      </div>
                    </div>
                  </div>

                  {/* Menu Items */}
                  <div className="py-1">
               

                    <div className="border-t border-gray-200 my-1"></div>

                    <button
                      onClick={handleLogout}
                      className="w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-red-50 transition-colors flex items-center gap-3"
                    >
                      <LogOut className="h-4 w-4" />
                      Sign Out
                    </button>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </nav>
  )
}

export default Navbar
